import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CustomOktaAuthService } from './oktaauth.service';

@Injectable()
export class CustomOktaAuthGuard implements CanActivate {
  constructor(private okta: CustomOktaAuthService, private router: Router) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const authenticated = await this.okta.isAuthenticated();

    // console.log("auth guard authenticated: ", authenticated);
    if (authenticated) { return true; }

    // Redirect to login flow.
    this.okta.login();
    return false;
    // const token = await this.okta.getIdToken();
    // console.log(token);
    // let authenticated = false;
    // console.log("--------token date----")
    // const currentDate = new Date(1592365566);//expires at
    // console.log("currentdate : ", currentDate);
    // console.log("Year = " + currentDate.getFullYear());
    // console.log("Date = " + currentDate.getDate());
    // console.log("Month = " + currentDate.getMonth());
    // console.log("Day = " + currentDate.getDay());
    // console.log("Hours = " + currentDate.getHours());
    // console.log("Minutes = " + currentDate.getMinutes());
    // console.log("Seconds = " + currentDate.getSeconds());
    // console.log("--------expired date----")
    // console.log(token.claims.iat + 3600);
    // const date = new Date(token.claims.iat + 3600);//issued at
    // console.log("Year = " + date.getFullYear());
    // console.log("Date = " + date.getDate());
    // console.log("Month = " + date.getMonth());
    // console.log("Day = " + date.getDay());
    // console.log("Hours = " + date.getHours());
    // console.log("Minutes = " + date.getMinutes());
    // console.log("Seconds = " + date.getSeconds());
    // console.log("--------current date----");
    // console.log(Date.now());
    // // //console.log(date);

    // if (token) {
    //   authenticated = true;
    // }

  }
}
